<template>
  <vx-card class="mb-6" title="How to Advertise your Check-In procedures">
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/2 mb-4" id="posterPDF">
        <Poster :data="data" />
      </div>
      <div class="vx-col w-full md:w-1/2 mb-4">
        <div class="tooltip-holder">
          <span class="tooltip">
            <p>Download a PDF of the poster to the left for display at your site informing people how to Check-in</p>
            <vs-button
              @click="printPDF"
              class="mt-2"
              icon-pack="feather"
              icon="icon-download"
              icon-before
              :disabled="isArchivedLocation"
            >PDF of Check-in Poster</vs-button>
          </span>
        </div>
        <div class="tooltip-holder mt-5">
          <span class="tooltip tooltip--none">
            <p>Download a PNG or SVG of just the QR code to add to use in your own design creative</p>
            <a download :href="`${qrSrc}?type=png`" class="mt-2">
              <vs-button class="mt-2" icon-pack="feather" icon="icon-download" icon-before :disabled="isArchivedLocation">PNG of QR Code</vs-button>
            </a>
            <a download :href="`${qrSrc}?type=svg`" class="mt-2">
              <vs-button class="mt-2" icon-pack="feather" icon="icon-download" icon-before :disabled="isArchivedLocation">SVG of QR Code</vs-button>
            </a>
          </span>
        </div>
      </div>
    </div>
  </vx-card>
</template>

<script>
import { baseURL, hostname } from '@/axios.js';
import Poster from '@/views/locations/components/Poster';
export default {
  components: { Poster },
  props: ['data', 'isArchivedLocation'],
  data () {
    return {
      baseURL,
      hostname
    }
  },
  computed: {
    qrSrc () {
      return `${this.baseURL}locations/${this.data.id}/qr`;
    }
  },
  methods: {
    printPDF () {
      if (this.$htmlToPaper) this.$htmlToPaper('posterPDF')
    }
  }
}
</script>
